(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-urgency"] && !Shopify.designMode) return;
  try {
    (() => {
    const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
    const pad = (value) => String(value).padStart(2, '0');
    const readNumber = (root, name, fallback) => {
      const value = Number(root.dataset[name]);
      return Number.isFinite(value) ? value : fallback;
    };
    const readStorage = (key) => {
      try {
        return sessionStorage.getItem(key);
      } catch {
        return null;
      }
    };
    const writeStorage = (key, value) => {
      try {
        sessionStorage.setItem(key, String(value));
      } catch {
        return;
      }
    };

    const initialize = (root) => {
      if (root.dataset.pdpUrgencyReady === 'true') return;
      root.dataset.pdpUrgencyReady = 'true';

      const productKey = root.dataset.productId || window.location.pathname;
      const countdownMinimum = Math.min(
        readNumber(root, 'countdownMin', 2280),
        readNumber(root, 'countdownMax', 3480)
      );
      const countdownMaximum = Math.max(
        readNumber(root, 'countdownMin', 2280),
        readNumber(root, 'countdownMax', 3480)
      );
      const countdownKey = 'gmcUrgencyCountdownEnd:storewide';
      const resetCountdown = () =>
        Date.now() + randomInt(countdownMinimum, countdownMaximum) * 1000;
      let countdownEnd = Number(readStorage(countdownKey));

      if (!Number.isFinite(countdownEnd) || countdownEnd <= Date.now()) {
        countdownEnd = resetCountdown();
        writeStorage(countdownKey, countdownEnd);
      }

      const days = root.querySelector('[data-pdp-urgency-days]');
      const hours = root.querySelector('[data-pdp-urgency-hours]');
      const minutes = root.querySelector('[data-pdp-urgency-minutes]');
      const seconds = root.querySelector('[data-pdp-urgency-seconds]');

      const renderCountdown = () => {
        let remaining = Math.floor((countdownEnd - Date.now()) / 1000);
        if (remaining <= 0) {
          countdownEnd = resetCountdown();
          writeStorage(countdownKey, countdownEnd);
          remaining = Math.floor((countdownEnd - Date.now()) / 1000);
        }
        if (days) days.textContent = '00';
        if (hours) hours.textContent = '00';
        if (minutes) minutes.textContent = pad(Math.floor(remaining / 60));
        if (seconds) seconds.textContent = pad(remaining % 60);
      };

      renderCountdown();
      window.setInterval(renderCountdown, 1000);

      const viewersNode = root.querySelector('[data-pdp-urgency-viewers]');
      if (viewersNode) {
        const viewersMinimum = Math.min(
          readNumber(root, 'viewersMin', 68),
          readNumber(root, 'viewersMax', 88)
        );
        const viewersMaximum = Math.max(
          readNumber(root, 'viewersMin', 68),
          readNumber(root, 'viewersMax', 88)
        );
        const viewersKey = `gmcUrgencyViewersV3:${productKey}`;
        const savedViewers = readStorage(viewersKey);
        let viewers = savedViewers === null ? Number.NaN : Number(savedViewers);
        if (!Number.isFinite(viewers)) viewers = randomInt(viewersMinimum, viewersMaximum);

        const renderViewers = () => {
          viewersNode.textContent = String(viewers);
          writeStorage(viewersKey, viewers);
        };
        const scheduleViewerChange = () => {
          window.setTimeout(() => {
            viewers += randomInt(-8, 8);
            renderViewers();
            scheduleViewerChange();
          }, randomInt(8, 18) * 1000);
        };

        renderViewers();
        scheduleViewerChange();
      }

      const stockNode = root.querySelector('[data-pdp-urgency-stock]');
      if (stockNode) {
        const stockMinimum = Math.min(
          readNumber(root, 'stockMin', 3),
          readNumber(root, 'stockMax', 6)
        );
        const stockMaximum = Math.max(
          readNumber(root, 'stockMin', 3),
          readNumber(root, 'stockMax', 6)
        );
        const stockKey = `gmcUrgencyStockV2:${productKey}`;
        const savedStock = readStorage(stockKey);
        let stock = savedStock === null ? Number.NaN : Number(savedStock);

        if (!Number.isFinite(stock)) {
          stock = randomInt(stockMinimum, stockMaximum);
          writeStorage(stockKey, stock);
        }
        stockNode.textContent = String(stock);
      }
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-pdp-urgency]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
    document.addEventListener('shopify:block:select', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
